import React, { useEffect, useState } from 'react';
import styles from './passwordStrengthChecker.module.css';

const PasswordStrengthChecker = (props) => {
    // State
    const [passwordStrengh, setPasswordStrengh] = useState(null);
    const [passwordLength, setPasswordLength] = useState(0);

    useEffect(() => {
        if (props.passwordData !== null && props.passwordData !== undefined) {
            setPasswordLength(props.passwordData.length);
            setPasswordStrengh(props.passwordData.value);
        } else {
            setPasswordStrengh(null);
        }
    }, [props.passwordData]);

    const tooWeak = () => {
        if (
            passwordLength > 0 &&
            (passwordStrengh === 'Too weak' ||
                passwordStrengh === 'Weak' ||
                passwordStrengh === 'Medium' ||
                passwordStrengh === 'Strong')
        ) {
            return '#87B04B';
        } else {
            return '#ccc';
        }
    };

    const weak = () => {
        if (
            passwordLength > 0 &&
            (passwordStrengh === 'Weak' ||
                passwordStrengh === 'Medium' ||
                passwordStrengh === 'Strong')
        ) {
            return '#87B04B';
        } else {
            return '#ccc';
        }
    };

    const medium = () => {
        if (
            passwordLength > 0 &&
            (passwordStrengh === 'Medium' || passwordStrengh === 'Strong')
        ) {
            return '#87B04B';
        } else {
            return '#ccc';
        }
    };

    const strong = () => {
        if (passwordLength > 0 && passwordStrengh === 'Strong') {
            return '#87B04B';
        } else {
            return '#ccc';
        }
    };

    return (
        <div className={styles.strengthIndicatorContainer}>
            <div
                style={{ backgroundColor: tooWeak() }}
                className={styles.indicator}
            ></div>
            <div
                style={{ backgroundColor: weak() }}
                className={styles.indicator}
            ></div>
            <div
                style={{ backgroundColor: medium() }}
                className={styles.indicator}
            ></div>
            <div
                style={{ backgroundColor: strong() }}
                className={styles.indicator}
            ></div>
        </div>
    );
};

export default PasswordStrengthChecker;
